//
//
//
//
//
//

export default {
    props: {
        content: {
            type: String,
            default: '喔唷，附近暂无数据呢~'
        }
    }
}
